"use strict";
exports.__esModule = true;
exports.SUPPORTED_CURRENCIES = void 0;
exports.SUPPORTED_CURRENCIES = [
    {
        name: 'United States Dollar',
        code: 'USD',
        id: 840
    },
    {
        name: 'Euro',
        code: 'EUR',
        id: 978
    },
    {
        name: 'Turkish Lira',
        code: 'TRY',
        id: 949
    },
    {
        name: 'Australian Dollar',
        code: 'AUD',
        id: 36
    },
    {
        name: 'Danish Krone',
        code: 'DKK',
        id: 208
    },
    {
        name: 'British Pound Sterling',
        code: 'GBP',
        id: 826
    },
    {
        name: 'Swiss Franc',
        code: 'CHF',
        id: 756
    },
    {
        name: 'Swedish Krona',
        code: 'SEK',
        id: 752
    },
    {
        name: 'Canadian Dollar',
        code: 'CAD',
        id: 124
    },
    {
        name: 'Kuwaiti Dinar',
        code: 'KWD',
        id: 414
    },
    {
        name: 'Norwegian Krone',
        code: 'NOK',
        id: 578
    },
    {
        name: 'Saudi Riyal',
        code: 'SAR',
        id: 682
    },
    {
        name: 'Japanese Yen',
        code: 'JPY',
        id: 392
    },
    {
        name: 'Bulgarian Lev',
        code: 'BGN',
        id: 975
    },
    {
        name: 'Romanian Leu',
        code: 'RON',
        id: 946
    },
    {
        name: 'Russian Ruble',
        code: 'RUB',
        id: 643
    },
    {
        name: 'Iranian Rial',
        code: 'IRR',
        id: 364
    },
    {
        name: 'Chinese Yuan',
        code: 'CNY',
        id: 156
    },
    {
        name: 'Pakistani Rupee',
        code: 'PKR',
        id: 586
    },
];
//# sourceMappingURL=supported-currencies.constant.js.map